'use strict';

var novicell = novicell || {};

novicell.overviewList = novicell.overviewList || new function () {

    this.init = function () {
        var element = document.querySelector('#js-overview-list');
        if (!element) return;
        var body = document.body;
        var siteNodeId = body.getAttribute('siteNodeId');
        new Vue({
            el: element,
            data: {
                params: {
                    siteNodeId: siteNodeId,
                    pageNumber: 1,
                    itemsPerPage: 1000,
                    selectedTag: '*'
                },
                overviewList: {}
            },
            methods: {
                init: function () {
                    this.list();
                },
                onFilterChange: function () {
                    this.resetParams();
                    this.list();
                },
                list: function () {
                    axios
                        .get('/api/overviewsApi/List', {
                            params: this.params
                        })
                        .then(response => {
                            this.overviewList = response.data;
                        })
                        .catch(error => (console.log(error)))
                },
                goToPreviousPage() {
                    this.params.pageNumber--;
                    this.list();
                },
                goToNextPage() {
                    this.params.pageNumber++;
                    this.list();
                },
                resetParams() {
                    this.params.pageNumber = 1;
                }
            },
            beforeMount() {
                this.init()
            }
        })
    }
}
